import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";
import { usePageMeta } from "../hooks/usePageMeta";

const SECTIONS = [
    {
        title: "1. About GoMedVoyage",
        body: "GoMedVoyage is a healthcare navigation and facilitation platform in its early validation and ecosystem-building phase. This website is provided for informational purposes and to connect with patients, hospitals, healthcare professionals, strategic partners and investors.",
    },
    {
        title: "2. No Medical Advice",
        body: "GoMedVoyage does not itself provide medical diagnosis or treatment. Medical care is provided independently by qualified healthcare professionals and healthcare institutions. Nothing on this website constitutes medical advice, and AI-generated information presented anywhere on the platform is intended to assist navigation only and does not replace professional medical judgment.",
    },
    {
        title: "3. Availability of Services",
        body: "Availability of healthcare services varies by location and provider. References to target markets, corridors and specialties describe areas of development focus and are subject to market validation and partnership development.",
    },
    {
        title: "4. Use of This Website",
        body: "You agree to use this website lawfully and not to submit false, misleading or malicious information through our forms. We may restrict access where misuse is detected.",
    },
    {
        title: "5. Intellectual Property",
        body: "All content on this website, including the GoMedVoyage name, logo and design, is the property of GoMedVoyage and may not be reproduced without permission.",
    },
    {
        title: "6. Limitation of Liability",
        body: "To the fullest extent permitted by law, GoMedVoyage is not liable for decisions made based on information on this website. Always consult a qualified healthcare professional regarding medical care.",
    },
    {
        title: "7. Contact",
        body: "For questions about these Terms of Use, please reach us through our contact page.",
    },
];

export default function TermsPage() {
    usePageMeta("Terms of Use | GoMedVoyage", "Terms governing use of the GoMedVoyage website.");
    return (
        <div data-testid="terms-page">
            <Header />
            <main className="pt-40 pb-28 bg-white">
                <div className="max-w-3xl mx-auto px-6 lg:px-8">
                    <p className="text-xs font-bold uppercase tracking-[0.25em] text-brand-green">Legal</p>
                    <h1 data-testid="terms-headline" className="mt-6 font-heading text-4xl sm:text-5xl font-bold tracking-tighter text-brand-blue">Terms of Use</h1>
                    <p className="mt-4 text-sm text-slate-500">Last updated: July 2026</p>
                    <div className="mt-12 space-y-10">
                        {SECTIONS.map((s) => (
                            <section key={s.title}>
                                <h2 className="font-heading text-xl font-semibold text-brand-blue">{s.title}</h2>
                                <p className="mt-3 text-base leading-relaxed text-slate-600">{s.body}</p>
                            </section>
                        ))}
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
